export default __webpack_public_path__ + "static/media/034-swiss-army-knife.9a1a3006.png";